import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization, WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
    .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message= translate("RequestLoginErrorMessage")
        if (_translate) {
          message=_translate;
        } else if (error.details) {
          message=error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
        <div className="login-audibel-container text-align-center" ref={nodeRef}>
          <div className="login-audibel-header" style={{ marginBottom: '40px' }}>
            <img src={logo} alt="logo" className="logo-audibel rounded mx-auto d-block" />
          </div>
          <div className="login-audibel-body">
            <Form onSubmit={event => onSubmit(event)}>
              <Col sm="12" xs="12" md="12" style={{ padding: '0px', textAlign: 'left' }}>
                <Input
                  className="input-audibel"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  placeholder={translate("PlaceholderUserName")}
                  onChange={e => setUsername(e.target.value)}

                />
              </Col>
              <Col sm="12" xs="12" md="12" style={{ padding: '0px', textAlign: 'left' }}>
                <Input
                  className="input-audibel"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder={translate("PlaceholderPassword")}
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
              {!onLogin ?
                <div className="row audibel-btns-row">
                  <div className="col-xs-12 col-md-12 col-lg-12">
                    <div>
                      <button
                        block={!parameters.failureRedirect}
                        tabIndex={1}
                        className="enter-audibel"
                        type="submit"
                        name="submit"
                        disabled={!props.turnstileSuccess}
                      >
                        {translate("ButtonEnter")}
                      </button>
                    </div>
                  </div>
                </div>
                :
                <Progress animated color="danger" value={100} />
              }
              <div className="messages-container">
                <Alert color="danger" id="error-message" isOpen={error.open} toggle={() => setError({ open: false })}>
                  {error.message}
                </Alert>
              </div>
              <div className="forgotaudibelText">
                <a href="https://audibel.ispcube.online/dgo/recoverpassword?company=628/">{translate("ForgotPassword")}</a>
              </div>
            </Form>
          </div>
        </div>
    </CSSTransition>
  );
}

export default WithCaptcha(WithLocalize(LoginForm));
